<template>
  <div class="modal modal-center" id="AddManuallyTrigger">
    <div class="modal-bg" @click="$emit('close')"></div>
    <div class="modal-block">
      <div class="modal-header">
        <h3>
          Manually Trigger Event
        </h3>
      </div>
      <div class="modal-body">
        <div class="text-center mt-3 mb-4" v-if="ui.loading === true">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="modal-body-container border-0" v-else>
          <div class="form-group full-width">
            <label for="fieldTaskPreset">
              Task Presets
            </label>
            <multiselect v-model="preset"
                         placeholder="Select Preset"
                         id="fieldTaskPreset"
                         :options="presets"
                         :searchable="true"
                         class="full-width"
                         :close-on-select="true"
                         :allow-empty="false"
                         :show-labels="false">
            </multiselect>
          </div>
          <div class="form-group full-width mt-3">
            <label for="fieldFile">
              Assign to File
            </label>
            <multiselect v-model="file"
                         placeholder="Select Preset"
                         id="fieldFile"
                         :options="files"
                         :searchable="true"
                         class="full-width"
                         :close-on-select="true"
                         :allow-empty="false"
                         :show-labels="false">
            </multiselect>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-start" v-if="ui.loading === false">
        <button class="btn btn-primary w-25" @click="saveTrigger">
           <span v-if="ui.saving === true"
                 class="spinner-border spinner-border-sm text-light"
                 role="status" aria-hidden="true">
          </span>
          <span class="text-end" v-else>
            Trigger
          </span>
        </button>
        <button class="btn btn-cancel ml-2" @click="$emit('close')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'AddManuallyTrigger',
  components: { Multiselect },
  data() {
    return {
      preset: '',
      file: '',
      presets: [],
      files: [],
      ui: {
        loading: false,
        saving: false
      }
    }
  },
  methods: {
    getData() {
      this.ui.loading = true;

      setTimeout(() => {
        this.ui.loading = false;
      }, 1000)
    },
    saveTrigger() {
      this.ui.saving = true;

      setTimeout(() => {
        this.ui.saving = false;
      }, 1000)
    }
  },
  created() {
    this.getData();
  }
}
</script>

<style lang="scss" scoped>
#AddManuallyTrigger {
  .modal-block {
    height: fit-content;
    margin: 50px auto;
    width: 600px;
    .modal-body {
      padding: 100px 30px 0 30px;
    }
    .modal-footer {
      bottom: unset;
    }
  }
}
</style>
